import { Spinner } from '@tempo-io/sui-spinner';

export const FullSizeSpinner = () => {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <Spinner size={32} />
    </div>
  );
};
